import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { Debug as DebugIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';

import { appVersion } from './app/global-variables';
if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://620eecddc0e743a18db6ce4e69477743@sentry.karafsapp.com/6',
  release: 'bento@' + appVersion,
  autoSessionTracking: false,
  integrations: [
    new DebugIntegration({
      // trigger DevTools debugger instead of using console.log
      debugger: false,

      // stringify event before passing it to console.log
      stringify: false,
    }),
    new Integrations.BrowserTracing({
      tracingOrigins: ['*'],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  ignoreErrors: ['TypeError'],
  beforeSend(event) {
    // or `value` instead of a `type`

    if (
      event.exception.values[0].value ===
      'Uncaught (in promise): Login providers not ready yet. Are there errors on your console?'
    ) {
      return null;
    }
    return event;
  },
  tracesSampleRate: 1.0,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
